import { noop, isEmpty } from 'lodash';
import React from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { hasAtLeastOnePrice } from 'Components/utils/price/price.util';
import type { ProductPriceInfoProps } from 'Components/widgets/product-price-info/ProductPriceInfo';
import 'Components/widgets/product-price-info/ProductPriceInfo';
import { getKeyValue } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Price } from 'Components/frameworks/price/Price';
import { ProductPriceModal } from 'Components/widgets/product-price-modal/ProductPriceModal';
import { themes } from './ProductFlag.themes';
export type ProductFlagProps = {
  className?: string;
  isLinkDisabled?: boolean;
  isPriceLoading?: boolean;
  onClick?: () => void;
  onCtaClick?: () => void;
  onEmptyPriceClick?: () => void;
  onIconBubbleClick?: () => void;
  onPriceClick?: () => void;
  price?: Record<string, any>;
  priceInfo?: ProductPriceInfoProps;
  theme?: keyof typeof themes;
  transportLabel?: string;
};
export const ProductFlag = ({
  isLinkDisabled = false,
  isPriceLoading = false,
  onClick = noop,
  onCtaClick = noop,
  onEmptyPriceClick = noop,
  onIconBubbleClick = noop,
  onPriceClick = noop,
  price = {},
  priceInfo = {},
  theme = 'thumbnail',
}: ProductFlagProps) => {
  if (isEmpty(price)) {
    return null;
  }

  const { thPriceTheme } = themes[theme];
  const hasPrice = !isPriceLoading && hasAtLeastOnePrice(price);

  const handleEmptyPriceClick = () => {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  const handlePriceClick = () => {
    onPriceClick && onPriceClick();
  };

  const handleProductPriceModalOnClickButton = () => {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  const priceNode = (
    <span className="flex gap-5">
      <button
        className="flex w-full items-center justify-end"
        onClick={hasPrice ? handlePriceClick : handleEmptyPriceClick}
        type="button"
      >
        <Price
          bestPrice={price.bestPrice}
          color={price.color || COLORS.SIENNA}
          data-testid="Price-wrapper"
          from={price.from}
          hasInitialPrice
          initialPrice={price.initialPrice}
          isLoading={isPriceLoading}
          theme={thPriceTheme}
          unit={price.unit}
          viewRates={price.viewRates}
        />
      </button>
      {hasPrice && getKeyValue('price.displayIconBubble') && (
        <button
          className="mt-5"
          onClick={() => onIconBubbleClick && onIconBubbleClick()}
          type="button"
        >
          <Icon className="text-sienna" name={ICONS.INFORMATION} width="1.25rem" />
        </button>
      )}
    </span>
  );
  return hasPrice ? (
    <ProductPriceModal {...priceInfo} onClickButton={handleProductPriceModalOnClickButton}>
      {priceNode}
    </ProductPriceModal>
  ) : (
    <div className="m-5">{priceNode}</div>
  );
};
